import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Pair } from '../interfaces/pair';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, throwError, Observable, defer, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PairService {
  private apiUrl = environment.apiUrl + 'pairs';

  constructor(private http: HttpClient) {}

  createPair(pairData: Pair): Observable<Pair> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    console.log(pairData);
    // Used to remove the linked list to avoid circular dependencies
    pairData = {
      ...pairData,
      donor: { ...pairData.donor, linkedRecipient: undefined },
      recipient: { ...pairData.recipient, linkedDonors: undefined }
    };
    return this.http.post<Pair>(this.apiUrl, pairData, { headers }).pipe(
      catchError((error) => {
        console.error('Error creating pair:', error);
        return throwError(() => new Error('Failed to create pair'));
      })
    );
  }

  getAllPairs(): Observable<Pair[]> {
    return this.http.get<Pair[]>(this.apiUrl).pipe(
      catchError((error) => {
        console.error('Error fetching pairs:', error);
        return throwError(() => new Error('Failed to fetch pairs'));
      })
    );
  }

  updatePair(pairData: Pair): Observable<Pair> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.patch<Pair>(`${this.apiUrl}/${pairData.id}`, pairData, { headers }).pipe(
      catchError((error) => {
        console.error('Error updating pair:', error);
        return throwError(() => new Error('Failed to update pair'));
      })
    );
  }

  deletePair(pairId: string, reasonRemoval: string): Observable<Pair> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.delete<Pair>(`${this.apiUrl}/${pairId}/${reasonRemoval}`, { headers }).pipe(
      catchError((error) => {
        console.error('Error deleting pair:', error);
        return throwError(() => new Error('Failed to delete pair'));
      })
    );
  }

  unpairPair(pairId: string, reasonRemoval: string): Observable<Pair> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<Pair>(`${this.apiUrl}/unpair/${pairId}/${reasonRemoval}`, {}, { headers }).pipe(
      catchError((error) => {
        console.error('Error unpairing pair:', error);
        return throwError(() => new Error('Failed to unpair pair'));
      })
    );
  }

  getPair(pairId: string): Observable<Pair> {
    return this.http.get<Pair>(`${this.apiUrl}/${pairId}`).pipe(
      catchError((error) => {
        console.error('Error getting pair:', error);
        return throwError(() => new Error('Failed to get pair'));
      })
    );
  }

  getPairByDonorId(donorId: string): Observable<Pair | null> {
    return this.http.get<Pair>(`${this.apiUrl}/donor/${donorId}`).pipe(
      catchError((error) => {
        if (error.status === 404) {
          return of(null);
        }
        console.error('Error getting pair by donor ID:', error);
        return throwError(() => new Error('Failed to get pair by donor ID'));
      })
    );
  }
}
